import { ComponentPropsWithoutRef } from "react";
import { Heading } from "~/components/elements/Heading";
import Grid from "~/components/globals/Grid";
import * as styles from "./SectionGridFourColumns.css";
import { CardArchive } from "~/components/components/cards/CardArchive";
import { IImage, Image } from "~/components/elements/Image";
import { Content } from "~/sanity/types";
import { Paragraph } from "~/components/elements/Paragraph";
import PortableText, {
  IPortableText,
} from "~/components/portableText/PortableText";
import { ILinkProps } from "~/components/elements/Link";
import { ButtonLink } from "~/components/elements/ButtonLink";
// @ts-ignore
import ArrowOutward from "@material-design-icons/svg/filled/arrow_outward.svg?react";
import { WrapperContentMask } from "~/components/wrappers/WrapperContentMask";

export type SectionGridFourColumnsProps = ComponentPropsWithoutRef<"div"> & {
  title?: string;
  text?: Content;
  link?: ILinkProps;
  hasBackgroundColor?: boolean;
};

export const SectionGridFourColumns = ({
  children,
  title,
  text,
  link,
  hasBackgroundColor = false,
  ...props
}: SectionGridFourColumnsProps) => {
  const grid = (
    <Grid
      className={styles.gridWrapper({ hasBackgroundColor: hasBackgroundColor })}
    >
      {(title || link) && (
        <div className={styles.header}>
          <div className={styles.headerText({ hasText: text ? true : false })}>
            {title && (
              <Heading as="h2" size="h1" uppercase>
                {title}
              </Heading>
            )}
            {text && <PortableText blocks={text as IPortableText} />}
          </div>
          {link && (
            <div>
              <div className={styles.link}>
                <ButtonLink
                  link={link}
                  theme="dark"
                  isPrimary={true}
                  icons={{ iconPrimary: <ArrowOutward /> }}
                >
                  {link.text}
                </ButtonLink>
              </div>
            </div>
          )}
        </div>
      )}

      <div className={styles.content}>
        <div className={styles.grid}>{children}</div>
      </div>
    </Grid>
  );

  return (
    <section>
      {hasBackgroundColor ? (
        <WrapperContentMask
          className={styles.wrapper({ hasBackgroundColor: hasBackgroundColor })}
        >
          {grid}
        </WrapperContentMask>
      ) : (
        <div
          className={styles.wrapper({ hasBackgroundColor: hasBackgroundColor })}
        >
          {grid}
        </div>
      )}
    </section>
  );
};
